// extracted by mini-css-extract-plugin
export default {"Emoji":"bbk_a bhk_i bhk_q bhk_j"};